import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

interface AdminGuardProps {
  children: React.ReactNode
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin, loading } = useAuthStore()

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
      </div>
    )
  }

  if (!isAdmin) return <Navigate to="/app" replace />

  return <>{children}</>
}
